// components/GetStarted.tsx
import React from "react";
import { Link } from "react-router-dom";

const GetStarted = () => {
  return (
    <div className="bg-gray-100 py-20 text-center">
      <h2 className="text-3xl sm:text-4xl font-bold text-orange-500">
        Get Started with Expert IT Support
      </h2>
      <p className="text-gray-800 mt-4 text-lg max-w-3xl mx-auto">
        Ensure your business operates smoothly and efficiently with our expert IT support solutions. <br />
        Contact us today to tailor a plan that meets your unique needs and drives your success.
      </p>
      <Link to="/contact">
  <button className="mt-8 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-10 py-3 rounded-full transition-all">
    Get Started Now
  </button>
</Link>
    </div>
  );
};

export default GetStarted;
